import React from "react";
import { ModeRendererProps } from "./types";

export function JansenMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Beach/desert background */}
      <rect x="0" y="0" width="794" height="600" fill={brand.deep} />
      <rect x="0" y="600" width="794" height="523" fill={brand.amber} opacity="0.15" />
      <path d="M0 620 C 150 600 650 640 794 620 V640 H0 Z" fill={brand.amber} opacity="0.2" />
      
      {/* Sun */}
      <circle cx="650" cy="150" r="60" fill={brand.amber} opacity="0.3" />
      <circle cx="650" cy="150" r="50" fill={brand.amber} opacity="0.5" />
      
      {/* Wind lines */}
      {Array.from({ length: 8 }).map((_, i) => (
        <path
          key={i}
          d={`M${50 + i * 30} ${120 + i * 50} C ${200 + i * 30} ${110 + i * 50} ${500 + i * 20} ${140 + i * 50} ${700} ${130 + i * 50}`}
          stroke={brand.aqua}
          strokeWidth="1"
          fill="none"
          opacity="0.2"
        />
      ))}
      
      {/* Strandbeest mechanism */}
      <g transform="translate(397 650)">
        {/* Main body */}
        <rect x="-180" y="-50" width="360" height="40" fill={brand.white} opacity="0.1" stroke={brand.white} strokeWidth="2" />
        
        {/* Sails */}
        <polygon points="0,-200 80,-80 -80,-80" fill="url(#sail)" opacity="0.8" />
        <line x1="0" y1="-200" x2="0" y2="-50" stroke={brand.white} strokeWidth="4" />
        
        {/* Legs (Jansen linkage) */}
        {[-140, -70, 0, 70, 140].map((x, i) => (
          <g key={i} transform={`translate(${x} -10)`}>
            <use href="#jansenLeg" transform={`scale(0.9) rotate(${(i % 2) * 15})`} />
          </g>
        ))}
        
        {/* Axle */}
        <line x1="-180" y1="-10" x2="180" y2="-10" stroke={brand.violet} strokeWidth="4" />
        <circle cx="-140" cy="-10" r="6" fill={brand.aqua} />
        <circle cx="-70" cy="-10" r="6" fill={brand.aqua} />
        <circle cx="0" cy="-10" r="6" fill={brand.aqua} />
        <circle cx="70" cy="-10" r="6" fill={brand.aqua} />
        <circle cx="140" cy="-10" r="6" fill={brand.aqua} />
      </g>
      
      {/* Footprints in sand */}
      {Array.from({ length: 12 }).map((_, i) => (
        <ellipse
          key={i}
          cx={50 + i * 60}
          cy={920 + (i % 2) * 20}
          rx="8"
          ry="12"
          fill={brand.white}
          opacity="0.15"
          transform={`rotate(${-30 + (i % 2) * 60} ${50 + i * 60} ${920 + (i % 2) * 20})`}
        />
      ))}
    </g>
  );
}
